export default __webpack_public_path__ + "static/media/DNo.5-5.f48c60e4.jpg";